function initSubscriptionWatcher(container) {
    if (!container) return false;

    resetQuantity(container);
    injectSubscriptionUI();
    insertDetails();
    separatePrice(container);

    return true;
}

/* =========================
   RE-INIT HANDLER
========================= */

function reInitSubscription() {
    const container = document.querySelector('#ongoing-subscriptions');
    if (!container) return;

    setTimeout(() => {
        initSubscriptionWatcher(container);
    }, 50);
}

/* =========================
   MAIN UI INJECTION
========================= */

function injectSubscriptionUI() {
    const targetContainer = document.querySelector('.os__purchase_type_subscription');
    const dropdown = document.querySelector('.product-form__input--dropdown');

    if (!targetContainer || !dropdown) return;

    // prevent duplicates (SCOPED FIX)
    if (targetContainer.querySelector('.custom-subscription-quantity')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-subscription-quantity';
    wrapper.innerHTML = `
        <div class="custom-subscription-note">
            <div class="form__label">Select Quantity</div>
            <div class="custom-quantity-selector__wrapper">
                <button class="custom-quantity-selector__button">
                    <span class="top-label"></span>
                    <span class="bottom-label">Save 10%</span>
                </button>
                <button class="custom-quantity-selector__button">
                    <span class="top-label"></span>
                    <span class="bottom-label">Save 15%</span>
                </button>
                <button class="custom-quantity-selector__button">
                    <span class="top-label"></span>
                    <span class="bottom-label">Save 20%</span>
                </button>
            </div>
        </div>
    `;

    dropdown.parentNode.insertBefore(wrapper, dropdown);

    addQuantityFunction();
}

/* =========================
   QUANTITY LOGIC
========================= */

function addQuantityFunction() {
    const container = document.querySelector('.custom-subscription-quantity');
    if (!container) return;

    const sizeFieldset = Array.from(document.querySelectorAll('.product-form__input')).find(fs => {
        const legend = fs.querySelector('legend');
        const text = legend?.textContent.trim().toLowerCase();
        return text === 'size' || text === 'package';
    });

    if (!sizeFieldset) return;

    const options = Array.from(sizeFieldset.querySelectorAll('input[type="radio"]'));
    const buttons = container.querySelectorAll('.custom-quantity-selector__button');

    buttons.forEach((button, index) => {
        const optionInput = options[index];
        if (!optionInput) return;

        const label = button.querySelector('.top-label');
        if (label) label.textContent = optionInput.value;

        button.addEventListener('click', () => {
            optionInput.checked = true;
            optionInput.dispatchEvent(new Event('change', { bubbles: true }));
            optionInput.click();

            const qtyInput = document.querySelector('.quantity__input');
            if (qtyInput) {
                qtyInput.value = 1;
                qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            buttons.forEach(b => b.classList.remove('active'));
            button.classList.add('active');

            const optionWrapper = button.closest('.os__purchase_type_subscription');
            const subInput = optionWrapper?.querySelector('input[value="subscription"]');
            if (subInput) subInput.click();
        });
    });

    const selectedIndex = options.findIndex(opt => opt.checked);

    buttons.forEach(b => b.classList.remove('active'));

    if (selectedIndex !== -1 && buttons[selectedIndex]) {
        buttons[selectedIndex].classList.add('active');
    } else if (buttons[0]) {
        buttons[0].classList.add('active');
    }
}

/* =========================
   DETAILS BLOCK
========================= */

function insertDetails() {
    const targetContainer = document.querySelector('.os__purchase_type_subscription');
    if (!targetContainer) return;

    if (targetContainer.querySelector('.custom-subscription-details')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-subscription-details';
    wrapper.innerHTML = `
        <div class="custom-subscription-details__wrapper">
            <div class="custom-subscription-details__item">
                <img src="https://cdn.shopify.com/s/files/1/0743/8824/2724/files/Giannos_Check.svg?v=1776142908" width="20" height="20" alt="Check"/>
                <span>Up to 20% off on every order</span>
            </div>
            <div class="custom-subscription-details__item">
                <img src="https://cdn.shopify.com/s/files/1/0743/8824/2724/files/Giannos_Check.svg?v=1776142908" width="20" height="20" alt="Check"/>
                <span>Free shipping within the US</span>
            </div>
            <div class="custom-subscription-details__item">
                <img src="https://cdn.shopify.com/s/files/1/0743/8824/2724/files/Giannos_Check.svg?v=1776142908" width="20" height="20" alt="Check"/>
                <span>Early access to new products</span>
            </div>
        </div>
    `;

    targetContainer.appendChild(wrapper);
}

/* =========================
   RESET QUANTITY
========================= */

function resetQuantity(container) {
    if (!container || container.dataset.bound) return;
    container.dataset.bound = "true";

    container.addEventListener('click', (e) => {
        const label = e.target.closest('.os_purchase_type_option_label');
        if (!label) return;

        const isSubscription = label.querySelector('input[value="subscription"]');

        if (!isSubscription) {
            const sizeFieldset = Array.from(document.querySelectorAll('.product-form__input')).find(fs => {
                const legend = fs.querySelector('legend');
                const text = legend?.textContent.trim().toLowerCase();
                return text === 'size' || text === 'package';
            });

            if (sizeFieldset) {
                const options = Array.from(sizeFieldset.querySelectorAll('input[type="radio"]'));
                const optionInput = options[0];

                if (optionInput) {
                    optionInput.checked = true;
                    optionInput.dispatchEvent(new Event('change', { bubbles: true }));

                    setTimeout(() => {
                        optionInput.click();
                    }, 0);

                    const buttons = container.querySelectorAll('.custom-quantity-selector__button');
                    buttons.forEach(b => b.classList.remove('active'));
                    if (buttons[0]) buttons[0].classList.add('active');
                }
            }
        }

        requestAnimationFrame(() => {
            const qtyInput = document.querySelector('.quantity__input');

            if (qtyInput) {
                qtyInput.value = 1;
                qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
                qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });
}

/* =========================
   PRICE LOGIC (UNCHANGED)
========================= */

function separatePrice(container) {
    const priceWrapper = document.querySelector('product-info');
    const priceContainer = priceWrapper?.querySelector('.product-price');

    if (!priceContainer) return;

    let lastPrice = null;
    let lastChangeTime = Date.now();
    let isFrozen = false;

    const FREEZE_AFTER = 2000;

    function wrapPrice(label) {
        if (!label) return;
        if (label.querySelector('.subscription-price')) return;

        const text = label.textContent;
        const match = text.match(/(\$\d+(\.\d{2})?)/);
        if (!match) return;

        const price = match[0];

        const cleanText = text
            .replace(price, '')
            .replace(/\s*—\s*/, ' ')
            .trim();

        label.innerHTML = `
            ${cleanText} <span class="subscription-price">${price}</span>
        `;
    }

    function injectOneTimeIntoSubscription() {
        const oneTime = container.querySelector(
            '.os__purchase_type_one_time_label .subscription-price'
        );

        const subscription = container.querySelector(
            '.os__purchase_type_subscription_label'
        );

        if (!oneTime || !subscription) return;

        const oneTimePrice = oneTime.textContent;

        const subscriptionPrice = subscription.querySelector('.subscription-price');
        if (!subscriptionPrice) return;

        let wrapper = subscription.querySelector('.subscription-wrapper');

        if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.className = 'subscription-wrapper';

            subscriptionPrice.parentNode.insertBefore(
                wrapper,
                subscriptionPrice.nextSibling
            );

            wrapper.appendChild(subscriptionPrice);
        }

        let existing = wrapper.querySelector('.subscription-default-price');

        if (!existing) {
            const span = document.createElement('span');
            span.className = 'subscription-default-price';
            span.textContent = oneTimePrice;
            wrapper.insertBefore(span, subscriptionPrice);
        } else {
            existing.textContent = oneTimePrice;
        }
    }

    function processAll() {
        container
            .querySelectorAll(
                '.os__purchase_type_subscription_label, .os__purchase_type_one_time_label'
            )
            .forEach(wrapPrice);

        injectOneTimeIntoSubscription();
    }

    function getCurrentPrice() {
        const priceEl = priceContainer.querySelector(
            '.price-item--sale, .price-item--regular'
        );

        return priceEl?.textContent?.trim() || null;
    }

    function handleMutation() {
        const currentPrice = getCurrentPrice();
        if (!currentPrice) return;

        const now = Date.now();

        if (currentPrice !== lastPrice) {
            lastPrice = currentPrice;
            lastChangeTime = now;
            isFrozen = false;

            processAll();
            return;
        }

        if (now - lastChangeTime >= FREEZE_AFTER) {
            isFrozen = true;
        }

        if (isFrozen) return;

        processAll();
    }

    processAll();

    new MutationObserver(handleMutation).observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
    });
}

/* =========================
   OBSERVERS (IMPORTANT FIX)
========================= */

const subsObserver = new MutationObserver(() => {
    const container = document.querySelector('#ongoing-subscriptions');

    if (container) {
        subsObserver.disconnect();
        initSubscriptionWatcher(container);
    }
});

subsObserver.observe(document.body, {
    childList: true,
    subtree: true
});

/* =========================
   VARIANT FIX (NEW)
========================= */

document.addEventListener('variant:change', reInitSubscription);

let lastUrl = location.href;

setInterval(() => {
    if (location.href !== lastUrl) {
        lastUrl = location.href;

        if (location.pathname.includes('/products/')) {
            reInitSubscription();
        }
    }
}, 300);

/* =========================
   INITIAL LOAD
========================= */

const container = document.querySelector('#ongoing-subscriptions');
if (container) initSubscriptionWatcher(container);